import { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Video } from "lucide-react";

export default function LaunchSettingsCard() {
  const [url, setUrl] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    (async () => {
      const { data } = await api.get("/settings/public");
      setUrl(data.launch_video_url || "");
    })();
  }, []);

  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.put("/settings", { launch_video_url: url || null });
      toast.success(url ? "Launch video saved — it's live on /launch" : "Launch video cleared");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="mt-10 rounded-xl border border-[#27272A] bg-[#121212] p-6" data-testid="launch-settings-card">
      <div className="flex items-center gap-2">
        <Video className="h-4 w-4 text-[#007AFF]" />
        <h2 className="font-black text-xl tracking-tight">Launch video</h2>
      </div>
      <p className="mt-1 text-xs text-neutral-500">
        Paste a YouTube or Loom link — it embeds instantly in the demo slot on the /launch page.
      </p>
      <form onSubmit={save} className="mt-4 flex flex-col sm:flex-row gap-3">
        <Input
          type="url"
          placeholder="https://www.youtube.com/watch?v=… or https://www.loom.com/share/…"
          value={url}
          onChange={(e) => setUrl(e.target.value)}
          data-testid="launch-video-input"
          className="bg-[#0A0A0A] border-[#27272A] flex-1"
        />
        <Button type="submit" disabled={busy} data-testid="launch-video-save-btn"
          className="bg-white text-black hover:bg-neutral-200 rounded-full h-10 px-6 font-semibold">
          {busy ? "Saving…" : "Save"}
        </Button>
      </form>
    </div>
  );
}
